// extracted by mini-css-extract-plugin
export default {"container":"Upload_container__WtfAz","text":"Upload_text__iw0yY","icons":"Upload_icons__Nm0IG","containerSecond":"Upload_containerSecond__2M8w4"};